export const ContractStatus = {
  DRAFT: { id: 34, name: 'Draft' },
  APCONTROLLER: { id: 35, name: 'Pending - A&P Controller' },
  APPROVED: { id: 36, name: 'Approved' },
} as const;

export type ContractStatusKey = keyof typeof ContractStatus;
export type ContractStatusType = typeof ContractStatus[ContractStatusKey];